(function () {
    'use strict';

    angular.module("imApp").factory("pickJobGrpsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 2164,
                    parameters: parms || {}
                });
            },
            listPickJobGroups: function (parms) {
                return $ihttp.post({
                    method: 2165,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
